import { render, staticRenderFns } from "./resource-list-title.vue?vue&type=template&id=64ada4b2&scoped=true&"
import script from "./resource-list-title.vue?vue&type=script&lang=js&"
export * from "./resource-list-title.vue?vue&type=script&lang=js&"
import style0 from "./resource-list-title.vue?vue&type=style&index=0&id=64ada4b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ada4b2",
  null
  
)

export default component.exports